/***********************************************************************
 *                           浏览器工具类                               *
 * ********************************************************************/

/**
 * 浏览器类型
 */
export function browserType() {
  var userAgent = navigator.userAgent //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf('Opera') > -1 //判断是否Opera浏览器
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !isOpera //判断是否IE浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 //判断是否IE的Edge浏览器
  var isFF = userAgent.indexOf('Firefox') > -1 //判断是否Firefox浏览器
  var isSafari = userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') == -1 //判断是否Safari浏览器
  var isChrome = userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1 //判断Chrome浏览器
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (fIEVersion == 7) return 'IE7'
    else if (fIEVersion == 8) return 'IE8'
    else if (fIEVersion == 9) return 'IE9'
    else if (fIEVersion == 10) return 'IE10'
    else if (fIEVersion == 11) return 'IE11'
    else return 'IE7以下' //IE版本过低
  }

  if (isFF) return 'FF'
  if (isOpera) return 'Opera'
  if (isEdge) return 'Edge'
  if (isSafari) return 'Safari'
  if (isChrome) return 'Chrome'
}
/**
 * 浏览器全屏
 */

export function reqFullScreen() {
  if (document.documentElement.requestFullScreen) {
    document.documentElement.requestFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.documentElement.webkitRequestFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.documentElement.mozRequestFullScreen()
  }
}

/**
 * 浏览器退出全屏
 */

export function exitFullScreen() {
  if (document.documentElement.requestFullScreen) {
    document.exitFullScreen()
  } else if (document.documentElement.webkitRequestFullScreen) {
    document.webkitCancelFullScreen()
  } else if (document.documentElement.mozRequestFullScreen) {
    document.mozCancelFullScreen()
  }
}



// WEBPACK FOOTER //
// ./src/utils/browser.js